module.exports = __webpack_public_path__ + "c6963005139acaf76d5b9a8f339ce672.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-notes/manage/manage-shared-note.html
// module id = 1800
// module chunks = 0